import { render, staticRenderFns } from "./CustomStatChartBar.vue?vue&type=template&id=a667daf8&scoped=true&"
import script from "./CustomStatChartBar.vue?vue&type=script&lang=ts&"
export * from "./CustomStatChartBar.vue?vue&type=script&lang=ts&"
import style0 from "./CustomStatChartBar.vue?vue&type=style&index=0&id=a667daf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a667daf8",
  null
  
)

export default component.exports